import { Flow } from './flow'
import type { ModelType } from 'src/types'

export default class GaiFlow {
  flowInstance: Flow

  constructor(model: ModelType) {
    const { dom } = model
    if (!dom) {
      throw new Error('cannot find root dom')
    }

    this.flowInstance = new Flow(model)
  }

  init(props: any) {
    this.flowInstance.init(props)
  }

  update(props: any) {
    this.flowInstance.update(props)
  }

  destoryed() {
    this.flowInstance.destoryed()
  }
}
